import React from 'react';
import SVGIcon, { SVGIcons } from './svgIcon';
import LinkText from './linkText';

interface Props {
  onDismiss?: () => void;
  lightTheme?: boolean;
  primary?: boolean;
}

const getClasses = ({primary, lightTheme}: Props) => 
  `badge ${primary ? 'badge_primary': lightTheme ? 'light_theme' : ''}`;

const Badge: React.FC<Props> = (props) => (
  <div className={getClasses(props)}>
    <span className="badge_content">{props.children}</span>
    {props.onDismiss && (
      <LinkText
        className="badge_dismiss"
        onClick={props.onDismiss}
        content={<SVGIcon name={SVGIcons.Dismiss} height="14px" width="14px" />}
      />
    )}
  </div>
);

export default Badge;
